import { Modal } from "./modal";
import { PropertyModalContent } from "./property-modal";

document.addEventListener("DOMContentLoaded", () => {
  const propertyModalEl = document.getElementById("property-modal");
  if (!propertyModalEl) return;

  const propertyModal = new Modal(propertyModalEl);
  propertyModal.init();

  const propertyContent = new PropertyModalContent(propertyModalEl);
  propertyContent.init();
});
